import permissionChecker from '@/utils/permission'

// 权限指令
export default {
  mounted(el, binding) {
    checkPermission(el, binding)
  },
  updated(el, binding) {
    checkPermission(el, binding)
  }
}

// 检查权限并控制元素显示
function checkPermission(el, binding) {
  const { value } = binding
  
  if (!value) {
    console.warn('权限指令需要传入权限标识')
    return
  }
  
  // 如果是数组，检查是否有任意一个权限
  if (Array.isArray(value)) {
    if (!permissionChecker.hasAnyPermission(value)) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  } 
  // 如果是字符串，检查单个权限
  else if (typeof value === 'string') {
    if (!permissionChecker.hasPermission(value)) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  }
  // 如果是对象，支持更多选项
  else if (typeof value === 'object') {
    const { permission, type = 'hide' } = value
    
    if (!permission) {
      console.warn('权限指令对象需要包含 permission 属性')
      return
    }
    
    const hasPermission = Array.isArray(permission) 
      ? permissionChecker.hasAnyPermission(permission)
      : permissionChecker.hasPermission(permission)
    
    if (!hasPermission) {
      if (type === 'hide') {
        el.style.display = 'none'
      } else if (type === 'disable') {
        el.disabled = true
        el.style.opacity = '0.5'
        el.style.pointerEvents = 'none'
      } else if (type === 'remove') {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      if (type === 'disable') {
        el.disabled = false
        el.style.opacity = '1'
        el.style.pointerEvents = 'auto'
      }
    }
  }
}